import { AbstractLobbyDetailVO } from "../../../gamevo/AbstractLobbyDetailVO";
import { TournamentLobbyDetailVO } from "../../../gamevo/TournamentLobbyDetailVO";
import { TournamentTablesLobbyDetailVO } from "../../../gamevo/TournamentTablesLobbyDetailVO";
import { ILobbyDetailComponent } from "./ILobbyDetailComponent";
import { LobbyDetailComponentType } from "./LobbyDetailComponentType";
import { TournamentTablesLobbyDetailComponent } from "./TournamentTablesLobbyDetailComponent";

import Container = createjs.Container;

export class LobbyDetailComponentFactory {
    private static _lobbyDetailComponentPool: Map<AbstractLobbyDetailVO, AbstractLobbyDetailVO> = new Map();

    public static getLobbyDetailComponent(lobbyDetailVO: AbstractLobbyDetailVO, holder: Container): ILobbyDetailComponent {
        var vo: AbstractLobbyDetailVO = new AbstractLobbyDetailVO();

        switch (vo.lobbyDetailType) {
            case 0:

                if (!LobbyDetailComponentFactory._lobbyDetailComponentPool.has(vo)) {
                    var tldVO: TournamentLobbyDetailVO = <TournamentLobbyDetailVO>lobbyDetailVO;
                    vo.lobbyDetailViewInstance = new TournamentLobbyDetailComponent(holder, tldVO);
                    LobbyDetailComponentFactory._lobbyDetailComponentPool.set(vo, vo);
                }

                holder.addChild(LobbyDetailComponentFactory._lobbyDetailComponentPool.get(vo).lobbyDetailViewInstance.view);
                break;

            case 1:

                if (!LobbyDetailComponentFactory._lobbyDetailComponentPool.has(vo)) {
                    var ttldVO: TournamentTablesLobbyDetailVO = <TournamentTablesLobbyDetailVO>lobbyDetailVO;
                    vo.lobbyDetailViewInstance = new TournamentTablesLobbyDetailComponent(holder, ttldVO);
                    LobbyDetailComponentFactory._lobbyDetailComponentPool.set(vo, vo);
                }

                holder.addChild(LobbyDetailComponentFactory._lobbyDetailComponentPool.get(vo).lobbyDetailViewInstance.view);
                break;
        }

        return vo.lobbyDetailViewInstance;
    }

    public static clearPool(): void {
        if (LobbyDetailComponentFactory._lobbyDetailComponentPool !== null) {
            LobbyDetailComponentFactory._lobbyDetailComponentPool.forEach(vo => {
                if (vo !== undefined) {
                    vo.lobbyDetailViewInstance.destroy();
                }
            });
        }

        LobbyDetailComponentFactory._lobbyDetailComponentPool = new Map();
    }
}
import { TournamentLobbyDetailComponent } from "./TournamentLobbyDetailComponent";
